import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'scitis-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
    standalone: false
})
export class ColorPickerComponent implements OnInit, OnChanges {

  @Input()
  signalColor: string = '';

  @Input()
  displayLabel = true;

  @Input()
  displayInput: boolean = true;

  @Input()
  disabled = false;

  @Output()
  selectedColor: EventEmitter<string> = new EventEmitter<string>();
  colorToggle: boolean = false;
  signalColorInput: string = '';

  ngOnInit() {
    this.signalColorInput = this.signalColor;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.signalColor && !this.colorToggle) {
      this.signalColorInput = changes.signalColor.currentValue ?? '';
    }
  }

  get inputClass(): string {
    if (this.displayInput) {
      return 'signal-color-input form-control';
    }
    return 'hide-input';
  }

  onCloseColorPicker($event: string) {
    this.signalColorInput = $event;
    this.selectedColor.emit($event);
  }

  toggleColorPicker() {
    if(!this.disabled) {
      this.colorToggle = !this.colorToggle;
    }
  }

}
